import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function AddIcon({ className, style, active, ...props }: IconProps & { active?: boolean }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <path
        d='M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z'
        stroke={active ? "#8B33FF" : "#5E678C"}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 8V16'
        stroke={active ? "#8B33FF" : "#5E678C"}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8 12H16'
        stroke={active ? "#8B33FF" : "#5E678C"}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
